import BasicModel from '../basic/BasicModel'
export default {
  findAllChannels (vm, listener) {
    let action = 'channel/findAllChannels.action'
    BasicModel.get(vm, action, null, listener)
  },
  findWithdrawChannels (vm, params, listener) {
    let action = 'channel/findWithdrawChannels.action'
    BasicModel.get(vm, action, params, listener)
  },
  findChannels (vm, params, listener) {
    let action = 'channel/findChannels.action'
    BasicModel.get(vm, action, params, listener)
  },
  findChannelsByKeyWord (vm, params, listener) {
    let action = 'channel/findChannelsByKeyWord.action'
    BasicModel.get(vm, action, params, listener)
  },
  changeStatus (vm, params, listener) {
    let action = 'channel/changeStatus.action'
    BasicModel.post(vm, action, params, listener)
  },
  insertChannel (vm, params, listener) {
    let action = 'channel/insertChannel.action'
    BasicModel.post(vm, action, params, listener)
  },
  updateChannel (vm, params, listener) {
    let action = 'channel/updateChannel.action'
    BasicModel.post(vm, action, params, listener)
  },
  updateServiceLevel (vm, params, listener) {
    let action = 'channel/updateServiceLevel.action'
    BasicModel.post(vm, action, params, listener)
  },
  findChannelSelectOption (vm, listener) {
    let action = 'channel/findChannelSelectOption.action'
    BasicModel.get(vm, action, null, listener)
  },
  existsChannelAccount (vm, params, listener) {
    let action = 'channel/existsChannelAccount.action'
    BasicModel.get(vm, action, params, listener)
  },
  existsBankIdCard (vm, params, listener) {
    let action = 'channel/existsBankIdCard.action'
    BasicModel.get(vm, action, params, listener)
  },
  changeChannelDel (vm, params, listener) {
    let action = 'channel/updateChannelDel.action'
    BasicModel.post(vm, action, params, listener)
  },
  setPincheConfig (vm, params, listener) {
    let action = 'channel/setPincheConfig.action'
    BasicModel.post(vm, action, params, listener)
  },
  selectPincheConfig (vm, params, listener) {
    let action = 'channel/selectPincheConfig.action'
    BasicModel.get(vm, action, params, listener)
  },
  findEmployees (vm, params, listener) { // 获取员工本月签到的详细数据
    let action = 'channel/findEmployees.action'
    BasicModel.get(vm, action, params, listener)
  },
  selectChannelByID (vm, params, listener) { // 根据id查询渠道信息
    let action = 'channel/selectChannelInfoByID.action'
    BasicModel.get(vm, action, params, listener)
  },
  updateMenus (vm, params, listener) { // 根据id查询渠道信息
    let action = 'channel/updateMenus.action'
    BasicModel.post(vm, action, params, listener)
  },
  updateQuestionMenus (vm, params, listener) { // 更新问题贴菜单
    let action = 'channel/updateQuestionMenus.action'
    BasicModel.post(vm, action, params, listener)
  },
  refreshLoginTime (vm, params, listener) { // 根据id查询渠道信息
    let action = 'channel/refreshLoginTime.action'
    BasicModel.get(vm, action, params, listener)
  },
  selectQRCode (vm, params, listener) { // 查询公众号二维码
    let action = 'channel/selectQRCode.action'
    BasicModel.get(vm, action, params, listener)
  },
  findOrderList (vm, params, listener) { // 获取订单列表
    let action = 'channel/findOrderList.action'
    BasicModel.get(vm, action, params, listener)
  },
  selectAccountMoney (vm, params, listener) { // 获取收入明细
    let action = 'channel/selectAccountMoney.action'
    BasicModel.get(vm, action, params, listener)
  },
  findPresentRecordList (vm, params, listener) { // 查询提现记录
    let action = '/channel/findPresentRecordList.action'
    BasicModel.get(vm, action, params, listener)
  },
  entPay (vm, params, listener) {
    let action = '/wechatPay/entPay'
    BasicModel.post(vm, action, params, listener)
  },
  changeEnableCarCoin (vm, params, listener) {
    let action = 'channel/changeEnableCarCoin.action'
    BasicModel.post(vm, action, params, listener)
  },
  selectChannelConfig (vm, params, listener) {
    let action = 'channel/selectChannelConfig.action'
    BasicModel.post(vm, action, params, listener)
  },
  updateChannelIndexTabConfig (vm, params, listener) {
    let action = 'channel/updateChannelIndexTabConfig.action'
    BasicModel.post(vm, action, params, listener)
  },
  updateChannelUsedCarSwitch (vm, params, listener) {
    let action = 'channel/updateChannelUsedCarSwitch.action'
    BasicModel.get(vm, action, params, listener)
  },
  updateChannelBottomTabConfig (vm, params, listener) {
    let action = 'channel/updateChannelBottomTabConfig.action'
    BasicModel.post(vm, action, params, listener)
  }
}
